import { render, staticRenderFns } from "./DocumentImport.vue?vue&type=template&id=ad4178a4&"
import script from "./DocumentImport.vue?vue&type=script&lang=ts&"
export * from "./DocumentImport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports